<header class="bg-white shadow">
    <div class="mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div class="lg:flex lg:items-center lg:justify-between">
            <div class="flex-1 min-w-0">
                <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
                    Index File Details
                </h2>
                <div *ngIf="summaryLoading" class="flex pt-1 px-0.5 text-gray-500 animate-pulse">
                    <span>Loading...</span>
                </div>
                <div *ngIf="!summaryLoading && taxDocSummary" class="flex pt-1">
                    <p class="pr-1 pl-0.5">Production Date: <strong>{{taxDocSummary.productionDate | date:
                            'shortDate'}}</strong></p>
                    <p class="px-1">Tax Form: <strong>{{taxDocSummary.taxDoc}}</strong> </p>
                    <p class="px-1">Tax Year: <strong>{{taxDocSummary.taxYear}}</strong> </p>
                    <p *ngIf="taxDocSummary.sent" class="px-1">Sent: <strong>Y</strong> </p>
                    <p *ngIf="!taxDocSummary.sent" class="px-1">Sent: <strong>N</strong> </p>
                    <p *ngIf="taxDocSummary.keyFormat != null" class="px-1">Entered By:
                        <strong>{{taxDocSummary.keyFormat}}</strong>
                    </p>
                </div>
            </div>
            <div *ngIf="!summaryLoading && !detailsLoading && !error" id="sendAll">
                <button *ngIf="!sendLoading && !taxDocSummary.sent"
                    class="bg-blue-700 hover:bg-blue-900 text-white py-2 px-4 rounded-full"
                    (click)="sendAllEmails()">Send All Emails
                </button>
                <button *ngIf="sendLoading"
                    class="bg-gray-300 text-black py-2 px-9 rounded-full cursor-not-allowed">
                    <span class="animate-pulse">Loading...</span>
                </button>
                <button *ngIf="!sendLoading && taxDocSummary.sent"
                    class="bg-gray-300 text-black py-2 px-4 rounded-full cursor-not-allowed">
                    Send All Emails
                </button>
            </div>
        </div>
    </div>
</header>

<app-message *ngIf="error" severity="error"></app-message>
<app-message *ngIf="sendSuccess" title="Success!" [text]="sendText" dismissible="true" (dismiss)="triggerDismiss()"
    severity="success"></app-message>
<app-message *ngIf="sendFailure" [text]="sendText" dismissible="true" (dismiss)="triggerDismiss()"
    severity="error"></app-message>

<div *ngIf="!error && detailsLoading" class="flex justify-center p-4 text-sm text-gray-500 animate-pulse">
    <span>Loading...</span>
</div>

<div *ngIf="!error && !detailsLoading && !summaryLoading">
    <div class="flex pt-6 px-4 lg:px-6">
        <form [formGroup]="searchForm" class="flex w-2/5">
            <div class="flex items-center border border-gray-300 bg-white mx-2 rounded-md">
                <div *ngIf="!taxDocSummary.sent">
                    <input id="accountSearchOnly" type="text" maxlength="12" inputmode="numeric" oninput="this.value = this.value.replace(/\D+/g, '')"
                        (keydown.enter)="search()" formControlName="search"
                        class="block py-2 px-3 mx-.5 bg-white border-none focus:outline-none rounded-md text-sm"
                        placeholder="Account Number" />
                </div>
                <div *ngIf="taxDocSummary.sent">
                    <input id="fullSearch" type="text" (keydown.enter)="search()" formControlName="search"
                        class="block py-2 px-3 mx-.5 bg-white border-none focus:outline-none rounded-md text-sm"
                        placeholder="Account Number or Email" />
                </div>
                <button id="clear" type="button" class="text-gray-500 text-sm mr-2" (click)="clearSearch()"> X </button>
            </div>
            <button *ngIf="!isValidInput()" id="search" type="button"
                class="bg-gray-300 text-black py-2 px-4 ml-1 rounded-md text-sm cursor-not-allowed">Search</button>
            <button *ngIf="isValidInput()" id="search" type="button"
                class="bg-blue-700 hover:bg-blue-900 text-white py-2 px-4 ml-1 rounded-md text-sm"
                (click)="search()">Search</button>
        </form>

        <div class="flex w-3/5 justify-end">
            <div id="firstPage">
                <button *ngIf="currentPage == 1 || pageSearchLoading || searchDisplayed"
                    class="bg-gray-300 text-black py-2 px-8 rounded text-sm cursor-not-allowed">First Page</button>
                <button *ngIf="currentPage != 1 && !pageSearchLoading && !searchDisplayed" 
                    class="bg-blue-700 hover:bg-blue-900 text-white py-2 px-8 rounded text-sm "
                    (click)="getFirstPage()">First Page</button>
            </div>

            <div id="previousPage" class="ml-3">
                <button *ngIf="currentPage == 1 || pageSearchLoading || searchDisplayed" 
                    class="bg-gray-300 text-black py-2 px-4 rounded text-sm cursor-not-allowed">Previous Page</button>
                <button *ngIf="currentPage > 1 && !pageSearchLoading && !searchDisplayed" 
                    class="bg-blue-700 hover:bg-blue-900 text-white py-2 px-4 rounded text-sm"
                    (click)="getPreviousPage()">Previous Page</button>
            </div>

            <div *ngIf="!searchDisplayed" id="page" class="flex min-h-full mt-2 ml-3 text-black text-sm">{{ "Page: " + currentPage + "/" + pageCount}}</div>
            <div *ngIf="searchDisplayed" id="page" class="flex min-h-full mt-2 ml-3 text-gray-500 text-sm">{{ "Page: " + currentPage + "/" + pageCount}}</div>

            <div id="nextPage" class="ml-3">
                <button *ngIf="currentPage == pageCount || pageSearchLoading || searchDisplayed" 
                    class="bg-gray-300 text-black py-2 px-8  rounded text-sm cursor-not-allowed">Next Page</button>
                <button *ngIf="currentPage != pageCount && !pageSearchLoading && !searchDisplayed" 
                    class="bg-blue-700 hover:bg-blue-900 text-white py-2 px-8 rounded text-sm" 
                    (click)="getNextPage()">Next Page</button>
            </div>

            <div id="lastPage" class="mx-3">
                <button *ngIf="currentPage == pageCount || pageSearchLoading || searchDisplayed" 
                    class="bg-gray-300 text-black py-2 px-8 rounded text-sm cursor-not-allowed">Last Page</button>
                <button *ngIf="currentPage != pageCount && !pageSearchLoading && !searchDisplayed" 
                    class="bg-blue-700 hover:bg-blue-900 text-white py-2 px-8 rounded text-sm" 
                    (click)="getLastPage()">Last Page</button>
            </div>
        </div>
    </div>

    <app-details-table [loadId]="loadId" [taxDocSummary]="taxDocSummary" [rows]="taxDocDetails"
        [searchNotFound]="searchNotFound" [pageSearchLoading]="pageSearchLoading"
        [searchError]="acctSearchError"></app-details-table>
</div>